"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCard = void 0;
const react_1 = __importDefault(require("react"));
const useCard = (components, title, caption, content, imageURL, imageALT) => {
    const headerElement = react_1.default.useCallback(() => {
        return ((components === null || components === void 0 ? void 0 : components.header) || (react_1.default.createElement("header", { className: "c-card-blog__header" },
            react_1.default.createElement("h5", { className: "c-card-blog__headerTitle" }, title || ''),
            react_1.default.createElement("span", { className: "c-card-blog__headerCaption" }, caption || ''))));
    }, [components === null || components === void 0 ? void 0 : components.header, title, caption]);
    const bodyContent = react_1.default.useCallback(() => {
        return ((components === null || components === void 0 ? void 0 : components.header) || (react_1.default.createElement("div", { className: "c-card-blog__body" }, content || '')));
    }, [components === null || components === void 0 ? void 0 : components.body, content]);
    const imageContent = react_1.default.useCallback(() => {
        if (components === null || components === void 0 ? void 0 : components.image) {
            return components === null || components === void 0 ? void 0 : components.image;
        }
        return (imageURL && (react_1.default.createElement("div", { className: "c-card-blog-blog__imageBackground" },
            react_1.default.createElement("img", { src: imageURL, className: "c-card-blog__image", alt: imageALT || '' }))));
    }, [components === null || components === void 0 ? void 0 : components.image, imageURL, imageALT]);
    return { headerElement, bodyContent, imageContent };
};
exports.useCard = useCard;
//# sourceMappingURL=useCard.js.map